import { UserIcon, SparkleBigIcon } from "../../common/icons";
import { useTranslation } from "react-i18next";
import "./style.css";

const FinalNotification = () => {
	const { t } = useTranslation();

	return (
		<div className="finalNotification_container">
			<div className="finalNotification_primaryHeader">
				{t("internship_determineStudent_finalStep_notification_title")}
			</div>
			<div className="finalNotification_logo">
				<UserIcon width={60} height={60} fill="#344054" />
				<SparkleBigIcon width={40} height={40} stroke="#344054" />
			</div>
			<div className="finalNotification_secondaryHeader">
				{t("internship_determineStudent_finalStep_notification_description")}
			</div>
		</div>
	);
};

export default FinalNotification;
